import { type Timestamp } from "@bufbuild/protobuf/wkt";
import type { FC } from "react";

import { timeAgo } from "@/format/time";
import { timestampDate } from "@/utils/timestamp";

const timeAgoFormat = new Intl.RelativeTimeFormat("en", {
    style: "long",
});

export const CreationTime: FC<{ timestamp?: Timestamp }> = ({ timestamp }) => {
    if (!timestamp) {
        return null;
    }
    const date = timestampDate(timestamp);
    const relative = timeAgo(date, timeAgoFormat);
    return <span title={date.toISOString()}>{relative}</span>;
};
